import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface RequisitionInfo {
  id: string;
  enquiryId: string;
  docNo: string;
  docDate: string;
  customerName: string;
  customerType: string;
  customerEmail: string;
  status: string;
  specialRequirements: string;
  finalComments: string;
  createdBy: string;
  createdByName: string;
  createdOn: string;
}

export interface ClassInfo {
  id: string;
  batchTitle: string;
  status: string;
  stage: string;
  participantCount: number;
  cloudConfigured: boolean;
  trainers: string[];
  dateRanges: { title: string; startDate: string; endDate: string; startTime: string; endTime: string }[];
}

export interface TemplateInfo {
  id: string;
  name: string;
  resourceType: string;
  description: string;
  status: string;
  cloudProvider: string;
  region: string;
  size: string;
  os: string;
  osVersion: string;
  sdkCount: number;
  dbCount: number;
  editorCount: number;
  miscCount: number;

  /// Metadata containing selected SDKs, Databases, Editors, and Miscellaneous tools
  metadata: SoftwareMetadata;

  policyTemplateId: string;
}

export interface SoftwareMetadata {
  /// List of selected SDK names (e.g., "Python", "Node.js")
  sdks: string[];

  /// List of selected Database names (e.g., "PostgreSQL", "MongoDB")
  databases: string[];

  /// List of selected Editor names (e.g., "VS Code", "Visual Studio")
  editors: string[];

  /// List of selected Miscellaneous tool names (e.g., "Git", "Docker")
  misc: string[];
}

export interface PolicyInfo {
  id: string;
  name: string;
  resourceType: string;
  description: string;
  activeCreationPolicy: string;
  activeDailyPolicy: string;
  activeClassEndPolicy: string;
}

export interface RequisitionDetailView {
  requisition: RequisitionInfo;
  class: ClassInfo | null;
  templates: TemplateInfo[];
  policies: PolicyInfo[];
}

@Injectable({ providedIn: 'root' })
export class RequisitionDetailViewService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  getDetailView(requisitionId: string): Observable<RequisitionDetailView> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.get<RequisitionDetailView>(
      `${this.apiUrl}/v1/requisitions/${requisitionId}/detail-view`,
      { headers }
    );
  }
}
